import React, { useCallback, useState } from 'react';
import { arrayOf, bool, func, number, shape, string } from 'prop-types';
import { rotateImage } from '../../utils/rotateImage';
import MediaContainer from './Components/MediaContainer';
import MobileReviewPopup from './Components/MobileReviewPopup';
import WebReviewPopup from './Components/WebReviewPopup';
const rotationAngle = 90;

const ProductReviewPopup = ({
  review,
  charLimit,
  mediaProps,
  selectedMedia,
  closePopup,
  changeCaroulsel
}) => {
  const [currentSlide, setCurrentSlide] = useState(selectedMedia);
  const [showRotateButton, setShowRotateButton] = useState(false);
  const [rotation, setRotation] = useState(0);
  const thumbnails = mediaProps.filter(item => item.thumbnails);
  const processedMedias = mediaProps.filter(item => item.processed);

  const verifyMediaType = index => {
    setShowRotateButton(processedMedias[index].mediaType !== 'video');
  };

  const handleSlideChange = index => {
    setCurrentSlide(index);
    verifyMediaType(index);
    changeCaroulsel(index);
  };

  const handleRotateImage = async () => {
    try {
      processedMedias[currentSlide].mediaUrl = await rotateImage(processedMedias[currentSlide].mediaUrl, rotationAngle);
      setRotation(prevRotation => prevRotation + rotationAngle);
    } catch (error) {
      console.error(`Falha ao rotacionar imagem: ${error}`);
    }
  };

  const renderMedia = useCallback(() => {
    return processedMedias.map((elem, index) => {
      return /*#__PURE__*/React.createElement(MediaContainer, {
        key: `slide-item-${elem.mediaUrl}`,
        media: elem,
        alt: '',
        currentSlide: currentSlide,
        index: index
      });
    });
  }, [mediaProps, currentSlide, rotation]);

  const closePopupAction = () => {
    document.body.style.overflow = 'visible';
    closePopup();
  };

  const renderPopup = () => {
    if (window.innerWidth >= 500) {
      return /*#__PURE__*/React.createElement(WebReviewPopup, {
        charLimit: charLimit,
        closePopup: closePopup,
        review: review,
        selectedMedia: selectedMedia,
        changeCaroulsel: handleSlideChange,
        thumbnails: thumbnails,
        showRotateButton: showRotateButton,
        onRotateImage: handleRotateImage
      }, renderMedia());
    }

    document.body.style.overflow = 'hidden';
    return /*#__PURE__*/React.createElement(MobileReviewPopup, {
      charLimit: charLimit,
      closePopup: closePopupAction,
      review: review,
      selectedMedia: selectedMedia,
      changeCaroulsel: handleSlideChange,
      showRotateButton: showRotateButton,
      onRotateImage: handleRotateImage
    }, renderMedia());
  };

  return renderPopup();
};

process.env.NODE_ENV !== "production" ? ProductReviewPopup.propTypes = {
  review: shape({
    rating: number,
    description: string,
    submissionDate: string,
    dimensionDefs: arrayOf(string),
    userData: shape({
      name: string
    })
  }),
  charLimit: number,
  mediaProps: arrayOf(shape({
    mediaUrl: string,
    mediaType: string,
    processed: bool,
    thumbnails: bool
  })),
  selectedMedia: number,
  closePopup: func,
  changeCaroulsel: func
} : void 0;
ProductReviewPopup.defaultProps = {
  charLimit: 110,
  changeCaroulsel: () => 0
};
export default ProductReviewPopup;